import { LOCALE_TAGS, type LanguageId } from './types'

/**
 * 날짜와 시각 표기를 Intl에 맡긴다. 자체 형식 함수를 두지 않는다.
 *
 * 형식기를 모듈 상수로 만들지 않고 언어마다 하나씩 만들어 붙들어 둔다. 생성 비용이 목록
 * 화면에서 항목마다 되풀이할 만큼 싸지 않다.
 *
 * 시간대는 언어를 따르지 않는다. 브라우저 시간대를 그대로 쓴다. 한국에 살면서 영어 화면을
 * 쓰는 사람이 있다. 서버는 UTC ISO-8601을 그대로 주고 표기는 화면이 만든다.
 */
export interface EntryFormatters {
  formatDate: (isoString: string) => string
  formatTime: (isoString: string) => string
}

const cache = new Map<LanguageId, EntryFormatters>()

export function formattersFor(languageId: LanguageId): EntryFormatters {
  const cached = cache.get(languageId)
  if (cached) return cached

  const locale = LOCALE_TAGS[languageId]
  const date = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'short',
  })
  const time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' })

  const formatters: EntryFormatters = {
    formatDate: (isoString) => date.format(new Date(isoString)),
    formatTime: (isoString) => time.format(new Date(isoString)),
  }
  cache.set(languageId, formatters)
  return formatters
}
